// extracted by css-extract-rspack-plugin
var _1 = "affected-packages-RIXGJ0";
var _2 = "affected-version-list-8h5Rpg";
var _3 = "affected-version-toggle-CQc3bw";
var _4 = "affected-packages-RIXGJ0";
var _5 = "affected-version-list-8h5Rpg";
var _6 = "affected-version-toggle-CQc3bw";
var _7 = "attributes-__4_4y";
var _8 = "attributes-vertical-CCpYwU";
var _9 = "attributes-vertical-CCpYwU";
var _a = "content-CtQ0Qo";
var _b = "content-framed-KoJXYp";
var _c = "content-framed-header-NVMJTB";
var _d = "content-framed-KoJXYp";
var _e = "content-framed-header-NVMJTB";
export { _1 as "affected-packages", _2 as "affected-version-list", _3 as "affected-version-toggle", _4 as "affectedPackages", _5 as "affectedVersionList", _6 as "affectedVersionToggle", _7 as "attributes", _8 as "attributes-vertical", _9 as "attributesVertical", _a as "content", _b as "content-framed", _c as "content-framed-header", _d as "contentFramed", _e as "contentFramedHeader" }
